import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { merge, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class CoreTranslationService {
  /**
   * Constructor
   *
   * @param {TranslateService} _translateService
   */
  constructor(private _translateService: TranslateService) {}

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param {Locale} args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them
      this._translateService.setTranslation(locale.lang, locale.data, true);
    });
  }


  public onTranslationLoad(): Observable<any>{

    const onLangChange = this._translateService.onLangChange;
    const onTranslationChange = this._translateService.onTranslationChange;

    const events = {
      onLangChange,
      onTranslationChange
    }

    return of(events).pipe(
      mergeMap(ev => {
        return merge(...Object.keys(ev).map(k => ev[k]));
      })
    );

  }

}
